import type {
  CreateOrganizationRequest,
  UpdateOrganizationRequest,
} from '@portal/pkg-api/gen/admin-console'
import type { OrgAdminFormValues } from '../model/orgAdminSchema'

function trimOrNull(value: string) {
  return value.trim() || null
}

function valueOrSingleSpace(value: string) {
  return value.trim().length <= 0 ? ' ' : value.trim()
}

export type SecretFieldName =
  | 'oauthAccessKey'
  | 'powerBiClientSecretId'
  | 'dbtSecretKey'
  | 'dbtWebhookKey'

function toCommonRequest(values: OrgAdminFormValues) {
  return {
    powerUserLimit: values.powerUser,
    integrationsEnabled: values.integrationsEnabled,
    entityTypeScopedAuthorizationEnabled: values.entityTypeScopedAuthorizationEnabled,
    powerBiWorkspaceId: trimOrNull(values.powerBiWorkspaceId),
    powerBiTenantId: trimOrNull(values.powerBiTenantId),
    powerBiClientId: trimOrNull(values.powerBiClientId),
    dbtAccountId: trimOrNull(values.dbtAccountId),
    dbtJobId: valueOrSingleSpace(values.dbtJobId),
  }
}

export function toCreateRequest(values: OrgAdminFormValues): CreateOrganizationRequest {
  return {
    name: values.orgName,
    uniqueId: values.orgUniqueId,
    ...toCommonRequest(values),
    oauthAccessKey: trimOrNull(values.oauthAccessKey),
    powerBiClientSecretId: trimOrNull(values.powerBiClientSecretId),
    dbtSecretKey: trimOrNull(values.dbtSecretKey),
    dbtWebhookKey: trimOrNull(values.dbtWebhookKey),
  }
}

export function toUpdateRequest(
  values: OrgAdminFormValues,
  dirtyFields: Partial<Record<SecretFieldName, boolean>>,
  clearedSecrets: ReadonlySet<SecretFieldName>,
): UpdateOrganizationRequest {
  return {
    description: values.description || null,
    ...toCommonRequest(values),
    ...((dirtyFields.oauthAccessKey || clearedSecrets.has('oauthAccessKey')) && {
      oauthAccessKey: trimOrNull(values.oauthAccessKey),
    }),
    ...((dirtyFields.powerBiClientSecretId || clearedSecrets.has('powerBiClientSecretId')) && {
      powerBiClientSecretId: trimOrNull(values.powerBiClientSecretId),
    }),
    ...((dirtyFields.dbtSecretKey || clearedSecrets.has('dbtSecretKey')) && {
      dbtSecretKey: trimOrNull(values.dbtSecretKey),
    }),
    ...((dirtyFields.dbtWebhookKey || clearedSecrets.has('dbtWebhookKey')) && {
      dbtWebhookKey: trimOrNull(values.dbtWebhookKey),
    }),
  }
}
